import { TransactionRepositoryImpl } from '../../packages/transaction/src/domain/Transaction/infrastructure';
import { TransactionServiceImpl } from '../../packages/transaction/src/domain/Transaction/usecases';
import { AccountRepositoryImpl } from '../../packages/account/src/domain/Account/infrastructure';
import { AccountServiceImpl } from '../../packages/account/src/domain/Account/usecases';
import { CardRepositoryImpl } from '../../packages/card/src/domain/Card/infrastructure/CardRepositoryImpl';
import { CardServiceImpl } from '../../packages/card/src/domain/Card/usecases/CardServiceImpl';
import { FavouriteTransfersRepositoryImpl } from '../../packages/fundTransfer/src/domain/FavouriteTransfer/infrastructure';
import { FavouriteTransfersServiceImpl } from '../../packages/fundTransfer/src/domain/FavouriteTransfer/usecases';
import { AuthorizationRepositoryImpl } from '../../packages/authorizations/src/domain/Authorization/infrastructure';
import { AuthorizationServiceImpl } from '../../packages/authorizations/src/domain/Authorization/usecases';
import { CurrencyRepositoryImpl } from '../../packages/fundTransfer/src/domain/Currency/infrastructure';
import { CurrencyServiceImpl } from '../../packages/fundTransfer/src/domain/Currency/usecases';
import { ExchangeCalculateRepositoryImpl } from '../../packages/fundTransfer/src/domain/ExchangeCalculate/infrastructure';
import { ExchangeCalculateServiceImpl } from '../../packages/fundTransfer/src/domain/ExchangeCalculate/usecases';
import { CountryRepositoryImpl } from '../../packages/fundTransfer/src/domain/Country/infrastructure';
import { CountryServiceImpl } from '../../packages/fundTransfer/src/domain/Country/usecases';
import { ChargingMethodRepositoryImpl } from '../../packages/fundTransfer/src/domain/ChargingMethod/infrastructure';
import { ChargingMethodServiceImpl } from '../../packages/fundTransfer/src/domain/ChargingMethod/usecases';
import { BeneficiaryServiceImpl } from '../../packages/beneficiary/src/domain/Beneficiary/usecases';
import { BeneficiaryRepositoryImpl } from '../../packages/beneficiary/src/domain/Beneficiary/infrastructure';
import { DeviceRepositoryImpl } from '../../packages/deviceManagement/src/domain/Device/infrastructure';
import { DeviceServiceImpl } from '../../packages/deviceManagement/src/domain/Device/usecases';
import { SecurityPreferencesServiceImpl } from '../../packages/iam/src/domain/SecurityPreferences/usecases';
import { SecurityPreferencesRepositoryImpl } from '../../packages/iam/src/domain/SecurityPreferences/infrastructure';
import { DashboardRepositoryImpl } from '../../packages/userProfile/src/domain/UserInfo/infrastructure';
import { DashboardServiceImpl } from '../../packages/userProfile/src/domain/UserInfo/usecases';
import { UserProfileRepositoryImpl } from '../../packages/userProfile/src/domain/UserProfile/infrastructure';
import { UserProfileServiceImpl } from '../../packages/userProfile/src/domain/UserProfile/usecases';
import { PayrollRepositoryImpl } from '../../packages/payroll/src/domain/Payroll/infrastructure';
import { PayrollServiceImpl } from '../../packages/payroll/src/domain/Payroll/usecases';
import { InternationalizationServiceImpl } from '../../packages/internationalization/src/domain/Internationalization/usecases/InternationalizationService';
import { InternationalizationRepositoryImpl } from '../../packages/internationalization/src/domain/Internationalization/infrastructure';
import { AliasRepositoryImpl } from '../../packages/account/src/domain/Alias/infrastructure';
import { AliasServiceImpl } from '../../packages/account/src/domain/Alias/usecases';
import { TransferServiceImpl } from '../../packages/fundTransfer/src/domain/Transfer/usecases';
import { TransferRepositoryImpl } from '../../packages/fundTransfer/src/domain/Transfer/infrastructure';
import { CommunicationRepositoryImpl } from '../../packages/userProfile/src/domain/Communication/infrastructure';
import { CommunicationServiceImpl } from '../../packages/userProfile/src/domain/Communication/usecases';

const internationalizationService = new InternationalizationServiceImpl(new InternationalizationRepositoryImpl());

const dashboardService = new DashboardServiceImpl(new DashboardRepositoryImpl());

const userProfileService = new UserProfileServiceImpl(new UserProfileRepositoryImpl());

const accountService = new AccountServiceImpl(new AccountRepositoryImpl());

const transactionService = new TransactionServiceImpl(new TransactionRepositoryImpl());

const cardService = new CardServiceImpl(new CardRepositoryImpl());

const favouriteTransfersService = new FavouriteTransfersServiceImpl(new FavouriteTransfersRepositoryImpl());

const authorizationService = new AuthorizationServiceImpl(new AuthorizationRepositoryImpl());

const currencyService = new CurrencyServiceImpl(new CurrencyRepositoryImpl());

const exchangeCalculateService = new ExchangeCalculateServiceImpl(new ExchangeCalculateRepositoryImpl());

const countryService = new CountryServiceImpl(new CountryRepositoryImpl());

const chargingMethodService = new ChargingMethodServiceImpl(new ChargingMethodRepositoryImpl());

const beneficiaryService = new BeneficiaryServiceImpl(new BeneficiaryRepositoryImpl());

const devicesService = new DeviceServiceImpl(new DeviceRepositoryImpl());

const securityPreferencesService = new SecurityPreferencesServiceImpl(new SecurityPreferencesRepositoryImpl());

const payrollService = new PayrollServiceImpl(new PayrollRepositoryImpl());

const aliasService = new AliasServiceImpl(new AliasRepositoryImpl());

const fundTransfersService = new TransferServiceImpl(new TransferRepositoryImpl());

const communicationService = new CommunicationServiceImpl(new CommunicationRepositoryImpl());

export {
  internationalizationService,
  dashboardService,
  userProfileService,
  accountService,
  transactionService,
  cardService,
  favouriteTransfersService,
  authorizationService,
  currencyService,
  exchangeCalculateService,
  countryService,
  chargingMethodService,
  beneficiaryService,
  devicesService,
  securityPreferencesService,
  payrollService,
  aliasService,
  fundTransfersService,
  communicationService,
};
